import React, { useState } from 'react';
import { LegalModal, PrivacyPolicyContent, TermsOfServiceContent } from './LegalModals';
export function Footer() {
  const [openModal, setOpenModal] = useState<null | 'privacy' | 'terms'>(null);
  return <footer className="bg-[#060E1A] border-t border-white/5 py-8 px-6 text-center" data-id="element-152">
      <div className="max-w-4xl mx-auto flex flex-col items-center" data-id="element-153">
        <div className="font-serif text-white/50 text-[13px] mb-6" style={{
        fontVariant: 'small-caps'
      }} data-id="element-154">
          DiLore Publishing
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 mb-4" data-id="element-155">
          <button onClick={() => setOpenModal('privacy')} className="text-white/35 text-[12px] hover:text-teal-400 transition-colors" data-id="element-156">
            Privacy Policy
          </button>
          <button onClick={() => setOpenModal('terms')} className="text-white/35 text-[12px] hover:text-teal-400 transition-colors" data-id="element-157">
            Terms
          </button>
          <a href="mailto:dilorepublishing@gmail.com" className="text-white/35 text-[12px] hover:text-teal-400 transition-colors" data-id="element-158">
            Contact
          </a>
          <button onClick={() => setOpenModal('terms')} className="text-white/35 text-[12px] hover:text-teal-400 transition-colors" data-id="element-159">
            Refund Policy
          </button>
        </div>

        <p className="text-white/25 text-[11px] leading-relaxed max-w-sm" data-id="element-160">
          © 2026 DiLore Publishing.
          <br data-id="element-161" />
          All rights reserved.
          <br data-id="element-162" />
          Results may vary.
          <br data-id="element-163" />
          This product is a digital download.
        </p>
      </div>

      <LegalModal isOpen={openModal === 'privacy'} onClose={() => setOpenModal(null)} title="Privacy Policy" data-id="element-164">
        <PrivacyPolicyContent data-id="element-165" />
      </LegalModal>

      <LegalModal isOpen={openModal === 'terms'} onClose={() => setOpenModal(null)} title="Terms of Service" data-id="element-166">
        <TermsOfServiceContent data-id="element-167" />
      </LegalModal>
    </footer>;
}